// src/components/MapComponent.js
import React from 'react';
import './MapComponent.css';

// London House School of English, Chiang Mai
const LAT = 18.79496;
const LNG = 98.98360;

const EMBED_SRC = `https://www.google.com/maps?q=${LAT},${LNG}&hl=en&z=18&output=embed`;
const DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${LAT},${LNG}`;

const MapComponent = () => {
  return (
    <div className="map-component">
      <iframe
        title="London House School of English location"
        className="map-component__frame"
        src={EMBED_SRC}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      ></iframe>
      <a
        className="map-component__directions"
        href={DIRECTIONS_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          className="map-component__directions-icon"
          viewBox="0 0 24 24"
          width="18"
          height="18"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M21.71 11.29l-9-9a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 0 1.42l9 9a1 1 0 0 0 1.42 0l9-9a1 1 0 0 0 0-1.42zM14 14.5V12h-4v3H8v-4a1 1 0 0 1 1-1h5V7.5l3.5 3.5z"
          />
        </svg>
        Get Directions
      </a>
    </div>
  );
};

export default MapComponent;
